import React, { useCallback } from 'react';
import { INotification } from 'services/CrmApi/types/NotificationTypes';
import FluidButton from 'ui/FluidButton';

interface INotificationsLoadMoreButtonProps {
  onLoadMoreClick: () => void;
  isLoading: boolean;
}

export const NotificationsLoadMoreButton: React.FC<INotificationsLoadMoreButtonProps> = ({
  onLoadMoreClick,
  isLoading,
}) => {
  const handleLoadMore = useCallback(() => {
    onLoadMoreClick();
  }, [onLoadMoreClick]);

  return (
    <FluidButton type="secondary" onClick={handleLoadMore} isLoading={isLoading}>
      Load More
    </FluidButton>
  );
};

interface INotificationsLoadMoreSectionProps {
  notificationsCount: number;
  notifications: INotification[];
  onLoadMoreClick: () => void;
  isFetchingNextPage: boolean;
}

export const NotificationsLoadMoreSection: React.FC<INotificationsLoadMoreSectionProps> = ({
  notificationsCount,
  notifications,
  onLoadMoreClick,
  isFetchingNextPage,
}) => {
  return (
    <div className="notifications-load-more flex flex-col items-center gap-[10px] mt-[10px] ">
      {notifications.length < notificationsCount ? (
        <NotificationsLoadMoreButton onLoadMoreClick={onLoadMoreClick} isLoading={isFetchingNextPage} />
      ) : null}
      <p className="font-pt-sans text-[13px] tracking-[0.52px] text-gray-100 m-0">
        Showing {notifications.length} of {notificationsCount} results
      </p>
    </div>
  );
};
